import type { BlueprintModuleKey } from '../../../model';

// SELECT_BLUEPRINT

export const SELECT_BLUEPRINT = 'state.actions.blueprint.SELECT_BLUEPRINT' as const;

export type SelectBlueprintAction = {
	type: typeof SELECT_BLUEPRINT;
	payload: {
		blueprintModuleKey: BlueprintModuleKey;
	};
};

export const selectBlueprintAction = (
	blueprintModuleKey: BlueprintModuleKey,
): SelectBlueprintAction => ({
	type: SELECT_BLUEPRINT,
	payload: {
		blueprintModuleKey,
	},
});

// CANCEL_SELECT_BLUEPRINT

export const CANCEL_SELECT_BLUEPRINT = 'state.actions.blueprint.CANCEL_SELECT_BLUEPRINT' as const;

export type CancelSelectBlueprintAction = {
	type: typeof CANCEL_SELECT_BLUEPRINT;
};

export const cancelSelectBlueprintAction = (): CancelSelectBlueprintAction => ({
	type: CANCEL_SELECT_BLUEPRINT,
});

// OPEN_BLUEPRINT_DIALOG

export const OPEN_BLUEPRINT_DIALOG = 'state.actions.blueprint.OPEN_BLUEPRINT_DIALOG' as const;

export type OpenBlueprintDialogAction = {
	type: typeof OPEN_BLUEPRINT_DIALOG;
};

export const openBlueprintDialogAction = (): OpenBlueprintDialogAction => ({
	type: OPEN_BLUEPRINT_DIALOG,
});

// CREATE_RULE

export const CREATE_RULE = 'state.actions.blueprint.CREATE_RULE' as const;

export type CreateRuleAction = {
	type: typeof CREATE_RULE;
};

export const createRuleAction = (): CreateRuleAction => ({
	type: CREATE_RULE,
});
